export default {
  data () {
    return {};
  },
}